import { FinishNewsletterPopupProps } from '@husky-x/cc-finish-newsletter-popup/dist/types/models';

export const FinishProductDifferencesMock = {
  header: '<h2>Scopri la gamma completa di Pastiglie Finish</h2>',
  borderedImage: true,
  navigationButton: {
    link: '/prodotti/',
    label: 'VEDI TUTTI I PRODOTTI',
  },
  useCheckmark: false,
  tables: [
    {
      title: 'FINISH',
      legend:
        '<ul>\n<li><sup>*</sup>con sporco ostinato</li>\n<li><sup>**</sup>vs. Finish Power</li>\n<li><sup>***</sup>Ingredienti: Enzimi</li>\n</ul>',
      rows: [
        {
          text: 'Pulizia',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt01d874eeb54068e2/675ac663098d398180241ecf/clean.svg',
        },
        {
          text: 'Brillantezza',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt177dda2593f21d6e/675ac6758adfae4b7b5f086d/shine.svg',
        },
        {
          text: 'Residui incrostati<sup>*</sup> da 48H',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blta7ff29c4d4cb9c60/675ac68a07400b7c3a1ad62d/dried-on.svg',
        },
        {
          text: 'Azione sgrassante',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blte987aa0c29b4412e/675ac69ba398c36c7f78c6d3/tough-on-grease.svg',
        },
        {
          text: 'Si scioglie rapidamente<sup>**</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt1a4ee7c6b6644fe6/675ac6d10203db4cecca4acd/fast-dissolving.svg',
        },
        {
          text: 'Protezione del vetro',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt3f8fa162118d5dc1/675ac6f40203db5e95ca4ad2/glass-protection.svg',
        },
        {
          text: 'Extra freschezza',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt0840f0e1facb28d8/675ac7048a5af42504e2d387/freshness-boost.svg',
        },
        {
          text: 'Contro lo sporco bruciato',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltbf9859abd79899aa/675ac7158a5af49bcce2d38d/burnt-on-stains.svg',
        },
        {
          text: 'Ingrediente giusto al momento giusto<sup>***</sup>',
          image:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blteafd518504e556e0/675ac7244197ebce023eb13f/right-ingredient-right-time-1.png',
        },
      ],
      columns: [
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltc50692ce0f6ef942/675ac7b44197eb1ab03eb149/3312823-FINISH_ULTIMATE_PLUS_FRESH_(3).webp',
          productName: 'ULTIMATE PLUS',
          productLink: '/prodotti/pastiglie-lavastoviglie/ultimate-plus/fresh/',
          color: 'gold-gradient',
          values: [
            {
              value: 5,
            },
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt77ae1f0cd8f47710/675ac7baf38e1a68b5bbb801/3312821-FINISH_ULTIMATE_FRESH_(2).webp',
          productName: 'ULTIMATE',
          productLink: '/prodotti/pastiglie-lavastoviglie/ultimate/fresh/',
          color: 'black-gradient',
          values: [
            {
              value: 4,
            },
            {
              value: 4,
            },
            {
              value: 3,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt0495eaa75281f58d/675ac7c2f4ce247750549f6a/3312820-FINISH_QUANTUM_FRESH_(2).webp',
          productName: 'QUANTUM',
          productLink: '/prodotti/pastiglie-lavastoviglie/quantum/fresh/',
          color: 'dark-blue-gradient',
          values: [
            {
              value: 3,
            },
            {
              value: 3,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
        {
          productImage:
            'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt8b4b95be43a24f79/675ac7c9665ec00031521cd0/3310614-FINISH_POWER_FRESH_(2).webp',
          productName: 'POWER',
          productLink: '/prodotti/pastiglie-lavastoviglie/power/fresh/',
          color: 'blue-gradient',
          values: [
            {
              value: 2,
            },
            {
              value: 2,
            },
            {
              value: 1,
            },
            {
              value: 1,
            },
          ],
        },
      ],
    },
  ],
};

export const FinishProductCardsMock = {
  cards: [
    {
      productName: 'FINISH ULTIMATE',
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt992034de625a3429/67aa9c7dcd588eb72e10432f/3312821-FINISH_ULTIMATE_FRESH.png',
      cardStyle: 'dark-blue',
      button: {
        link: '/prodotti/pastiglie-lavastoviglie/ultimate/fresh/',
        text: 'SCOPRI ULTIMATE',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt7060facb1242eba3/675ac876c628ea0b227d122b/tough-on-grease-outline-red.webp',
          name: 'AZIONE SGRASSANTE',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt4a8fd9e8bb60aec0/675ac87cc139ca7f80049ecc/dried-on-stains-outline-red.webp',
          name: 'CONTRO I RESIDUI INCROSTATI<sup>*</sup> DA <strong>48</strong>H',
          styleType: 'text-on-image',
        },
      ],
      mobileOrder: 2,
    },
    {
      productName: 'FINISH ULTIMATE PLUS',
      primary: true,
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltc3d04d6467c9c32e/67aa9cda4aa2120a9224b11b/3312823-FINISH_ULTIMATE_PLUS_FRESH.png',
      cardStyle: 'black',
      button: {
        link: '/prodotti/pastiglie-lavastoviglie/ultimate-plus/fresh/',
        text: 'SCOPRI ULTIMATE PLUS',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blta6f2b29b35692008/675ac8838a5af4c997e2d398/extra-cleaning-power-outline-gold.webp',
          name: '<strong>3X</strong> POTERE PULENTE',
          styleType: 'text-on-image',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt6f3e4dd92fe969be/675ac88919771e3128a86604/tough-on-grease-gold-outline-gold.webp',
          name: 'AZIONE SGRASSANTE',
        },
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltec1e49d4fe07f621/675ac89006d859654d7b536e/burnt-on-stains-outline-gold.webp',
          name: 'CONTRO LO SPORCO BRUCIATO',
        },
      ],
      mobileOrder: 1,
    },
    {
      productName: 'FINISH QUANTUM',
      image:
        'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt4949aaa65fca335c/67aa9c060353bd290ffa5a7f/3312820-FINISH_QUANTUM_FRESH.png',
      cardStyle: 'light-blue',
      button: {
        link: '/prodotti/pastiglie-lavastoviglie/quantum/fresh/',
        text: 'SCOPRI QUANTUM',
      },
      icons: [
        {
          src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt7060facb1242eba3/675ac876c628ea0b227d122b/tough-on-grease-outline-red.webp',
          name: 'AZIONE SGRASSANTE',
        },
      ],
      mobileOrder: 3,
    },
  ],
};

export const FinishNewsletterPopupMock: FinishNewsletterPopupProps = {
  headline: 'NICHTS MEHR VERPASSEN',
  description:
    'Melden Sie sich über das folgende Formular für den Finish Newsletter an und bleiben Sie immer auf dem neuesten Stand rund um Finish! Mit betätigen des ANMELDEN-Buttons willigen Sie ein, von RB Hygiene Home Deutschland GmbH Informationen zu aktuellen Angeboten, Aktionen und anderen Neuigkeiten zur Finish Marke per E-Mail zu erhalten.',
  image: {
    src: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt7512496341f5a468/66f53c689441d6ee01fe1a7d/newsletter_popup_image.png',
    mobileSrc:
      'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt63c4941b86e10813/66f53c833097ebb254ddd0d8/newsletter_popup_image_mobile.png',
    alt: 'finish',
  },
  thankYou: {
    headline: 'VIELEN DANK FÜR IHRE ANMELDUNG FÜR DEN FINISH NEWSLETTER!',
    description: '',
    closeButton: {
      label: 'schließen',
      redirectUrl: '/',
    },
  },
  form: {
    id: '7f4311c4-00e3-48f9-a9cb-13b20ef2b28f',
    url: 'https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms',
    submitErrorMessage: 'Bitte füllen Sie die erforderlichen Felder aus.',
  },
};

export const FinishImageMapHouseMock = {
  map: [
    {
      shape: 'poly',
      coords: '199,325,162,199,214,78,268,79,393,0,391,323',
      alt: 'DOPPIO PULSANTE RISPARMIA 80% AD OGNI SCARICO',
      tooltip:
        '<p>Un WC con sistema di scarico a doppio pulsante consuma solo 4,5 litri d’acqua per uno scarico completo e 3 litri d’acqua per uno scarico parziale, facendo risparmiare circa 35.000 litri d’acqua per unità abitativa in un anno.</p>',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt0c2fa0874820e192/686d18c4980c66ebd4c96777/action1.png',
      },
      xPosition: '',
      yPosition: '',
    },
    {
      shape: 'poly',
      coords: '394,323,394,1,624,201,588,322',
      alt: 'SOFFIONE MODERNO Risparmia 50% al minuto',
      tooltip:
        '<p>Un soffione per la doccia moderno ed efficiente consuma solo 9 litri d’acqua al minuto, facendo risparmiare circa 20.000 litri d’acqua a persona in un anno.</p>',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltc46842e51058a6ad/686d18c4dfb31b186d4059bb/action2.png',
      },
      xPosition: '',
      yPosition: '',
    },
    {
      shape: 'poly',
      coords: '3,540,1,305,201,304,198,540',
      alt: 'LAVATRICE Risparmia 6,5% a pieno carico',
      tooltip:
        '<p>Alcune delle nuove lavatrici regolano in automatico la quantità d’acqua in base al carico; tuttavia, effettuare lavaggi soltanto a pieno carico fa risparmiare circa 10 litri d’acqua per lavaggio.</p>',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt01e71d372f216cbf/686d18c4ef96dd4491fca948/action3.png',
      },
      xPosition: '',
      yPosition: '',
    },
    {
      shape: 'poly',
      coords: '202,537,203,326,393,324,393,539',
      alt: 'LAVASTOVIGLIE Risparmia 90% per ogni carico',
      tooltip:
        '<p>Una lavastoviglie consuma solo 12 litri d’acqua ad ogni lavaggio, facendo risparmiare circa 110 litri d’acqua al giorno rispetto al lavaggio a mano.</p>',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltd7b8ccbe630df6f2/686d18c4a6c72f234d6f1cf0/action4.png',
      },
      xPosition: '',
      yPosition: '',
    },
    {
      shape: 'poly',
      coords: '396,539,393,323,586,323,584,542',
      alt: 'RUBINETTI A RISPARMIO IDRICO Risparmia 50% al minuto',
      tooltip:
        '<p>I rubinetti con riduttore di flusso consumano fino a 8 litri d’acqua al minuto, permettendo un risparmio di circa 300.000 litri d’acqua per unità abitativa ogni anno.</p>',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt0088d28beb581dc0/686d18c4a207aed48aade8a8/action5.png',
      },
      xPosition: '',
      yPosition: '',
    },
    {
      shape: 'poly',
      coords: '587,543,587,323,759,326,759,542',
      alt: 'IRRIGAZIONE A GOCCIA Risparmia 99% all’ora',
      tooltip:
        '<p>L’installazione di un irrigatore a goccia permette di consumare solo 4 litri d’acqua all’ora, facendo risparmiare fino a 996 litri d’acqua all’ora rispetto ai sistemi tradizionali.</p>',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt4bac2ae43b3bc7a4/686d18c4980c66735cc9677b/action6.png',
      },
      xPosition: '',
      yPosition: '',
    },
  ],
};

export const FinishImageMapDropMock = {
  map: [
    {
      shape: 'poly',
      coords: '238,2,197,90,213,126,255,137,281,98',
      alt: 'DOPPIO PULSANTE RISPARMIA 80% AD OGNI SCARICO',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltd7dc333f8c9e5058/686d30a060603f76a067a66b/actionDrop1.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '288,151,277,184,269,203,254,224,243,246,243,276,257,297,276,309,308,302,329,285,337,263,334,239',
      alt: 'rubinetto normale 16 litri al minuto',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt0973bcd1ef09979f/686d30a09b1f360782197a8f/actionDrop2.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '162,241,164,258,163,282,163,304,163,328,162,354,171,379,187,393,202,402,224,404,250,397,265,382,274,361,272,341,257,319',
      alt: 'lavatrice 150 litri per carico',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/bltb61db3ef09a55c9d/686d30a0206dd3c7b3f7a681/actionDrop3.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '343,217,349,238,350,253,350,282,342,309,330,326,317,342,303,351,281,378,273,404,273,436,281,453,307,482,329,494,369,491,407,477,429,451,440,408,427,346,396,283',
      alt: 'sciacquone classico 18 litri per scarico',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt6e119d0f248597a7/686d30a1a502a8c50af993d1/actionDrop4.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '107,238,97,248,82,265,59,292,43,323,25,351,10,395,2,437,6,471,23,494,48,517,67,524,118,526,149,505,163,489,180,447,159,398,126,368,109,340,95,298',
      alt: 'irrigatore da giardino 1,000 litri all’ora',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt1373abd8d76bf8ac/686d30a0d3b17ac7c583a411/actionDrop5.png',
      },
    },
    {
      shape: 'poly',
      coords:
        '189,110,185,126,177,149,164,179,161,208,165,223,181,238,199,246,224,240,245,227,245,204',
      alt: 'soffione classico 20 litri al minuto',
      tooltip: '',
      activeState: {
        url: 'https://eu-images.contentstack.com/v3/assets/bltf66eb2ba30842434/blt75b6b276893a78cb/686d30a04a604a623444d9ae/actionDrop6.png',
      },
    },
  ],
};
